module.exports = __webpack_public_path__ + "img/0Q3A5767_L_BlackMatted.99960906.jpg";